var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Cta from '../shared/Cta.vue';
import Loader from '../shared/Loader.vue';
import Choices from 'choices.js';
const service = namespace('Service');
let JobList = class JobList extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.args = {};
        this.list = [];
        this.select1 = null;
        this.select2 = null;
        this.select3 = null;
        this.selectProps = {
            searchEnabled: true,
            shouldSort: false,
            removeItemButton: true,
            itemSelectText: ''
        };
    }
    mounted() {
        this.args = {
            siteId: window.cibbic.siteId,
        };
        this.select1 = new Choices('#filter1', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'filter1Label' }));
        this.select2 = new Choices('#filter2', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'filter2Label' }));
        this.selectProps.removeItemButton = false;
        this.selectProps.searchEnabled = false;
        this.select3 = new Choices('#filter3', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'filter3Label' }));
        this.select3.setChoices([{ value: 'alpha', label: this.labels.orderAlphabetically, selected: true }, { value: 'date', label: this.labels.orderPostDate }]);
        this.getJobs(this.args);
    }
    onFilter1Changed(evt) {
        this.filterList();
    }
    onFilter2Changed(evt) {
        this.filterList();
    }
    onFilter3Changed(evt) {
        this.sortList();
    }
    filterList() {
        var _a, _b;
        const filter1 = (_a = this.select1) === null || _a === void 0 ? void 0 : _a.getValue(true);
        const filter2 = (_b = this.select2) === null || _b === void 0 ? void 0 : _b.getValue(true);
        const temp = this.list = this.jobsData.entries;
        this.createOptions('jobFunction', this.select1);
        this.createOptions('jobLocation', this.select2);
        if (filter1) {
            this.list = temp.filter(item => item.jobFunction.some(type => type.id === filter1));
            this.createOptions('jobLocation', this.select2);
        }
        if (filter2) {
            this.list = this.list.filter(item => item.jobLocation.some(location => location.id === filter2));
            this.createOptions('jobFunction', this.select1);
        }
        this.sortList();
    }
    sortList() {
        this.list.sort((a, b) => {
            var _a;
            if (((_a = this.select3) === null || _a === void 0 ? void 0 : _a.getValue(true)) === 'alpha') {
                return a.title.localeCompare(b.title);
            }
            else {
                return new Date(b.postDate).getTime() - new Date(a.postDate).getTime();
            }
        });
    }
    createOptions(key, select) {
        let options = [];
        this.list.forEach(job => {
            if (job[key].length > 0) {
                let exist = options.find((f) => { return f.value === job[key][0].id; });
                if (!exist) {
                    options.push({ value: job[key][0].id, label: job[key][0].title });
                }
            }
        });
        select === null || select === void 0 ? void 0 : select.setChoices(options, 'value', 'label', true);
    }
    onJobsDataChange() {
        this.loading = false;
        this.list = this.jobsData.entries;
        this.createOptions('jobFunction', this.select1);
        this.createOptions('jobLocation', this.select2);
        this.sortList();
    }
};
__decorate([
    Prop({ type: Object })
], JobList.prototype, "labels", void 0);
__decorate([
    service.State
], JobList.prototype, "jobsData", void 0);
__decorate([
    service.Action
], JobList.prototype, "getJobs", void 0);
__decorate([
    Watch('jobsData')
], JobList.prototype, "onJobsDataChange", null);
JobList = __decorate([
    Component({
        components: {
            Cta,
            Loader
        }
    })
], JobList);
export default JobList;
